export default "__VITE_ASSET__Csil0yqk__"